import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Component = lazy(() =>
  import("@scenes/SubscriptionPages/components/SubscriptionGroupsPage/SubscriptionGroupsPageNRO").then(
    (module) => ({
      default: module.SubscriptionGroupsPageNRO,
    })
  )
);

export const subscriptionGroupsNRO: NavigationRoutingObject = {
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => {
    return t("subscription-group-management-sidebar-pill-menu-option", "Subscription Group Management");
  },
  description: (t: I18nT<"dashboard-navigation">) =>
    t("subscription-groups-description-nav", "Manage your subscription groups for applicable channels"),
  icon: "nav-system-subscriptions",
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  shouldShowTertiaryNavigationCallback: ({ featureOn }) => {
    return featureOn("subscription_analytics");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("subscription-groups", "Subscription Groups")],
      description: t("previously-subscription-groups", 'Previously "Subscription Groups"'),
    },
    {
      keywords: [t("subscription-groups-email-preference-center", "Email Preference Center")],
      description: t(
        "previously-email-preference-center",
        'Previously "Email Preference Center" in "Subscription Groups"'
      ),
    },
    {
      keywords: [
        t("subscription-groups-alt-keyword-1", "subscription group timeseries"),
        t("subscription-groups-alt-keyword-2", "preference center"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  Component: Component,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  defaultRoute: "/users/subscription_groups/subscription_groups/:appGroupId",
};
